import { keyframes } from '@vanilla-extract/css';
import { themeVars } from '../theme/vars';
import { style } from '../layer.css';

const pulse = keyframes({
  from: {
    backgroundColor: themeVars.container.secondary.background.idle,
  },
  to: {
    backgroundColor: themeVars.badge.primary.background.active,
  },
});

export const skeleton = style({
  animation: `${pulse} 1000ms infinite alternate-reverse`,
});
